import React from 'react';
import { Grid, Row, Col } from '../utils/bootstrap';
import { Helmet } from 'react-helmet';

const documents = [
  {
    name: 'Customer brochure',
    link: '/eflyer_customer_20181004.pdf',
  },
  {
    name: 'Agent brochure',
    link: '/eflyer_agent_20181004.pdf',
  },
  {
    name: 'Pamphlet',
    link: '/pamphlet_20181004.pdf',
  },
  {
    name: 'Application form',
    link: '/application_form_20181004.pdf',
  },
];

class Downloads extends React.Component {
  state = {
    company: '',
    person: '',
    address: '',
    phone: '',
    email: '',
    message: '',
    error: {},
    formMessage: '',
    formMessageType: '',
    loading: false,
  };

  componentDidMount(prevProps) {
    window.scrollTo(200, 0);
  }

  handleMapLoad(map) {
    this._mapComponent = map;
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>Downloads | Premium Capital Partners</title>
          <meta name="description" content="Download documents from Premium Capital Partners and explore how our innovative business financing products can help support your business needs." />
        </Helmet>
        <Grid>
          <h2 className="text-center">Downloads</h2>
          <Row>
            <Col xs={12}>
              <ul className="list">
                {
                  documents.map(d => (
                    <li>
                      <a href={d.link} target="_blank">{d.name}</a>
                    </li>
                  ))
                }
              </ul>
            </Col>
          </Row>
          <Row>
            For more information about Premium Financing <a href="/contact-us">contact us</a> today.
          </Row>
        </Grid>
      </div>
    );
  }
}

export default Downloads;



// WEBPACK FOOTER //
// ./src/screens/Downloads.js